import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
// import { HashRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from './pages/Dashboard.js';
import LandingPage from './pages/LandingPage.js';
import Login from './pages/Login.js';
import MyProperties from './pages/MyProperties.js';
import Notification from './pages/Notification.js';
import Profile from './pages/Profile.js';
import Register from './pages/Register.js';
import TopListing from './pages/TopListing.js';
import ProtectedRoute from "./pages/ProtectedRoute.js";
import DashboardHomeProperties from "./components/DashboardHomeProperties.js";
import {  AuthProvider } from "./context/AuthContext.js";
import { PropertyProvider } from "./context/PropertyContext.js";
import PropertyReview from "./components/PropertyReview.js";
import { CommentProvider } from "./context/commentContext.js";
import { ReplyProvider } from "./context/ReplyContext.js";
import Admin from "./pages/Admin.js";
import Users from "./components/Users.js";
import Properties from "./components/Properties.js";
import AdminProtectedRoute from "./pages/AdminProtectedRoute.js";
import { NotificationProvider } from "./context/NotificationContext.js";




function App(){
    return(
        <AuthProvider>
            <PropertyProvider>
                <CommentProvider>
                    <ReplyProvider>
                        <NotificationProvider>
                            <Router >
                                <Routes>
                                    <Route path="/" element={<LandingPage />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/register" element={<Register />} />
                                    <Route path="/admin" element={<AdminProtectedRoute><Admin /></AdminProtectedRoute>}>
                                        <Route index element={<Navigate replace to= 'users' />} />
                                        <Route path="users" element={<Users />} />
                                        <Route path="properties" element={<Properties />} />
                                    </Route>
                                    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
                                        <Route index element={<Navigate replace to="homeproperties" />} />
                                        <Route path="homeproperties" element={<DashboardHomeProperties />} />
                                        <Route path="homeproperties/:id" element={<PropertyReview />} />
                                        <Route path="myproperties" element={<MyProperties />} />
                                        <Route path="notification" element={<Notification />} />
                                        <Route path="profile" element={<Profile />} />
                                        <Route path="topListing" element={<TopListing />} />
                                    </Route>
                                    <Route path="*" element={<div>Page Not Found</div>} />
                                </Routes>
                            </Router>
                        </NotificationProvider>
                
                    </ReplyProvider>
                
                </CommentProvider>
            </PropertyProvider>

        </AuthProvider>
      
    )
}

export default App;